import HomeReservationsItem from './HomeReservationsItem'

export default HomeReservationsItem